/* Milennia Search — Predictive Search dropdown for Shopify OS 2.0 themes.
 * No dependencies. Initialises every .ms-search root on the page. */
(function () {
  'use strict';

  var SUGGEST_URL = '/search/suggest.json';
  var DEBOUNCE_MS = 200;
  var ROTATE_PAUSE = 1800;
  var ROTATE_DEL = 28;
  var ROTATE_ADD = 55;

  var DEFAULT_CHIPS = ['Profhilo', 'PRX-T33', 'Revolax', 'Restylane', 'Juvederm'];

  var _svgUniqueIdx = 0;
  function uniquifySvg(html, prefix) {
    return html
      .replace(/\bid="([^"]+)"/g, function(_, id) { return 'id="' + prefix + '-' + id + '"'; })
      .replace(/\burl\(#([^)]+)\)/g, function(_, id) { return 'url(#' + prefix + '-' + id + ')'; })
      .replace(/\bhref="#([^"]+)"/g, function(_, id) { return 'href="#' + prefix + '-' + id + '"'; });
  }

  function vendorLogoSvg(vendor) {
    _svgUniqueIdx++;
    var slug = (vendor || '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    var aliases = { 'prx-t33': 'prx', 'prxt33': 'prx', 'k-surgery': 'ksurgery', 'rrs': 'rrs-ha', 'rrs-ha-hl': 'rrs-ha' };
    if (aliases[slug]) slug = aliases[slug];
    var span = document.querySelector('.ms-logos-library [data-brand="' + slug + '"]');
    if (!span) return null;
    return uniquifySvg(span.innerHTML.trim(), 'msv' + _svgUniqueIdx);
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function formatMoney(cents, currency) {
    var n = typeof cents === 'string' ? parseFloat(cents) : cents;
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'sv-SE', {
        style: 'currency',
        currency: currency || 'SEK',
        maximumFractionDigits: 0
      }).format(n);
    } catch (e) {
      return n.toFixed(0) + ' ' + (currency || '');
    }
  }

  function fetchSuggest(q) {
    var url = SUGGEST_URL +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,vendor,product_type,tag';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('suggest http ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        return products;
      })
      .catch(function () { return []; });
  }

  function deriveVendors(products) {
    var seen = {};
    var out = [];
    for (var i = 0; i < products.length; i++) {
      var v = products[i].vendor;
      if (!v) continue;
      var key = v.toLowerCase();
      if (seen[key]) continue;
      seen[key] = true;
      out.push(v);
    }
    return out;
  }

  function vendorHref(vendor) {
    return '/collections/vendors?q=' + encodeURIComponent(vendor);
  }

  function productHref(p) {
    return p.url || ('/products/' + p.handle);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderProductRow(p, idx, activeIdx) {
    var img = p.featured_image && (p.featured_image.url || p.image);
    var price = '';
    if (p.price) price = formatMoney(p.price, p.price_currency || (p.price_min_currency));
    return (
      '<a class="ms-row' + (idx === activeIdx ? ' is-active' : '') + '" href="' + escapeHtml(productHref(p)) + '" data-idx="' + idx + '">' +
        '<div class="ms-thumb">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy">' : escapeHtml((p.title || '?').slice(0,1))) +
        '</div>' +
        '<div class="ms-body">' +
          '<div class="ms-title">' + escapeHtml(p.title || '') + '</div>' +
          (p.vendor ? '<div class="ms-sub">' + escapeHtml(p.vendor) + '</div>' : '') +
        '</div>' +
        (price ? '<div class="ms-price">' + escapeHtml(price) + '</div>' : '') +
      '</a>'
    );
  }

  function renderVendorRow(v, idx, activeIdx) {
    var svgHtml = vendorLogoSvg(v);
    return (
      '<a class="ms-vendor-card' + (idx === activeIdx ? ' is-active' : '') + '" href="' + escapeHtml(vendorHref(v)) + '" data-idx="' + idx + '">' +
        '<div class="ms-vendor-logo-wrap">' +
          (svgHtml ||
            '<span class="ms-vendor-initial">' + escapeHtml((v || '?').slice(0,1).toUpperCase()) + '</span>'
          ) +
        '</div>' +
        '<span class="ms-vendor-name">' + escapeHtml(v) + '</span>' +
      '</a>'
    );
  }

  function initRoot(root) {
    if (root.dataset.msInit === '1') return;
    root.dataset.msInit = '1';

    var input = $('.ms-input', root);
    var clearBtn = $('.ms-clear', root);
    var dropdown = $('.ms-dropdown', root);

    var placeholders = (root.dataset.placeholders || '').split('\n').map(function(s){return s.trim();}).filter(Boolean);
    if (placeholders.length === 0) placeholders = ['Sök produkter...'];

    var staticChips = (root.dataset.chips || '').split('\n').map(function(s){return s.trim();}).filter(Boolean);

    var state = {
      raw: '',
      q: '',
      open: false,
      active: 0,
      products: [],
      vendors: [],
      chips: staticChips.length > 0 ? staticChips.slice() : DEFAULT_CHIPS.slice(),
      flat: []
    };

    /* Typewriter placeholder */
    (function rotate() {
      if (placeholders.length < 2) {
        input.setAttribute('placeholder', placeholders[0] || '');
        return;
      }
      var idx = 0, charIdx = placeholders[0].length, phase = 'pause';
      input.setAttribute('placeholder', placeholders[0]);
      function tick() {
        if (state.open || state.raw) {
          return setTimeout(tick, 800);
        }
        var current = placeholders[idx];
        if (phase === 'pause') { phase = 'deleting'; return setTimeout(tick, ROTATE_PAUSE); }
        if (phase === 'deleting') {
          charIdx--;
          input.setAttribute('placeholder', current.slice(0, charIdx));
          if (charIdx <= 0) { idx = (idx + 1) % placeholders.length; phase = 'typing'; return setTimeout(tick, 200); }
          return setTimeout(tick, ROTATE_DEL);
        }
        var next = placeholders[idx];
        charIdx++;
        input.setAttribute('placeholder', next.slice(0, charIdx));
        if (charIdx >= next.length) { phase = 'pause'; return setTimeout(tick, 10); }
        setTimeout(tick, ROTATE_ADD);
      }
      setTimeout(tick, 1500);
    })();

    function setOpen(v) { state.open = v; render(); }
    function setRaw(v) {
      state.raw = v;
      clearBtn.style.display = v ? '' : 'none';
      doSearch();
    }

    var doSearch = debounce(function () {
      var q = state.raw.trim();
      state.q = q;
      state.active = 0;
      if (!q) { state.products = []; state.vendors = []; state.flat = []; render(); return; }
      fetchSuggest(q).then(function (products) {
        if (state.q !== q) return;
        state.products = products.slice(0, 5);
        state.vendors = deriveVendors(products).slice(0, 4);
        state.flat = []
          .concat(state.products.map(function (p) { return { kind: 'product', href: productHref(p) }; }))
          .concat(state.vendors.map(function (v) { return { kind: 'vendor', href: vendorHref(v) }; }));
        render();
      });
    }, DEBOUNCE_MS);

    function render() {
      if (!state.open) { dropdown.hidden = true; dropdown.innerHTML = ''; return; }
      var html = '';
      if (!state.q) {
        if (state.chips.length === 0) { dropdown.hidden = true; return; }
        html += '<div class="ms-meta">Populärt</div><div class="ms-chips">';
        state.chips.forEach(function (c) {
          html += '<button type="button" class="ms-chip" data-chip="' + escapeHtml(c) + '">' + escapeHtml(c) + '</button>';
        });
        html += '</div>';
      } else if (state.products.length || state.vendors.length) {
        html += '<div class="ms-group">';
        if (state.products.length) {
          html += '<div><div class="ms-meta">Produkter</div>';
          state.products.forEach(function (p, i) { html += renderProductRow(p, i, state.active); });
          html += '</div>';
        }
        if (state.vendors.length) {
          html += '<div><div class="ms-meta">Varumärken</div><div class="ms-vendor-grid">';
          state.vendors.forEach(function (v, i) {
            var idx = state.products.length + i;
            html += renderVendorRow(v, idx, state.active);
          });
          html += '</div></div>';
        }
        html += '</div>';
      } else {
        html += '<div class="ms-empty">Inga träffar för "' + escapeHtml(state.q) + '".</div>';
      }
      dropdown.innerHTML = html;
      dropdown.hidden = false;
    }

    /* Events */
    input.addEventListener('focus', function () { setOpen(true); });
    input.addEventListener('input', function (e) { setRaw(e.target.value); if (!state.open) setOpen(true); });
    input.addEventListener('keydown', function (e) {
      if (!state.open) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); state.active = Math.min(state.active + 1, Math.max(state.flat.length - 1, 0)); render(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); state.active = Math.max(state.active - 1, 0); render(); }
      else if (e.key === 'Enter') {
        var it = state.flat[state.active];
        if (it) { e.preventDefault(); window.location.href = it.href; }
        else if (state.raw) { e.preventDefault(); window.location.href = '/search?q=' + encodeURIComponent(state.raw); }
      } else if (e.key === 'Escape') { setOpen(false); input.blur(); }
    });
    clearBtn.addEventListener('click', function () { input.value = ''; setRaw(''); input.focus(); });
    dropdown.addEventListener('click', function (e) {
      var chip = e.target.closest('.ms-chip');
      if (chip) { input.value = chip.dataset.chip; setRaw(chip.dataset.chip); input.focus(); }
    });
    document.addEventListener('mousedown', function (e) {
      if (!root.contains(e.target)) setOpen(false);
    });

    /* Initial */
    clearBtn.style.display = 'none';
  }

  function initAll() { $$('.ms-search').forEach(initRoot); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
